module.exports = __webpack_public_path__ + "img/tour-35.e6b15f7c.png";